'use client';
import { Button } from '@curology/ui-components-web/react/Button';
import React from 'react';
import { type SurveyModel } from 'survey-core';

const BackButton = ({
  model,
  isFirstPage,
  onFirstPageBack,
  goBackToEditingPhoneNumber,
  handleVerifyPhoneNumberPageBackOnClickForSkin,
}: {
  model: SurveyModel;
  isFirstPage: boolean;
  onFirstPageBack: () => void;
  goBackToEditingPhoneNumber?: boolean;
  handleVerifyPhoneNumberPageBackOnClickForSkin?: () => void;
}) => {
  const handleOnClick = () => {
    if (
      goBackToEditingPhoneNumber &&
      handleVerifyPhoneNumberPageBackOnClickForSkin
    ) {
      handleVerifyPhoneNumberPageBackOnClickForSkin();
    } else {
      model.prevPage();
    }
  };

  return (
    <Button
      buttonType="text"
      className="cur-w-full !cur-text-primary"
      onClick={isFirstPage ? onFirstPageBack : handleOnClick}
    >
      Back
    </Button>
  );
};

export default BackButton;
